import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['messages']
  static values = { url: String, enabled: Boolean }

  connect() {
    if (this.enabledValue) this.refreshTimer = setInterval(() => this.refresh(), 30000)
  }

  disconnect() {
    clearInterval(this.refreshTimer)
  }

  refresh() {
    if (!this.enabledValue || document.hidden || !this.hasMessagesTarget) return

    const frame = this.messagesTarget
    if (frame.hasAttribute('busy') || frame.getAttribute('aria-busy') === 'true') return
    // Keep a keyboard user's selected message in place until they leave the list.
    if (frame.contains(document.activeElement)) return

    if (frame.src) frame.reload()
    else frame.src = this.urlValue
  }
}
